export type AttributeOption = {
    value?: string;
    range?: {
        minimum: string | number;
        maximum: string | number;
        increment: string | number;
    };
};

// Shared by EachProductVariable.tsx, ProductVariables.tsx, and SurfaceVariables.tsx -- all three
// render variable configuration UI driven by the same attribute-option shape.
export interface AttributesOption {
    name: string;
    type: string;
    values: AttributeOption[];
}

// `defaultValue` is generic because callers pass different shapes for it (a plain string, an
// array, or an action object like `{ action: 'Use Default' }`) depending on the kind of variable
// being defaulted -- see EachProductVariable.tsx and SurfaceVariables.tsx.
export const getDefaultForAttributeValues = <T>(options: AttributeOption[], defaultValue: T): Record<string, T> => {
    const defaultValues: Record<string, T> = {};

    options.forEach((eachOption) => {
        if (eachOption.value) {
            defaultValues[eachOption.value] = defaultValue;
        } else if (eachOption.range) {
            const range = eachOption.range;
            // if the range is only 5 or less values use them as if they are string values
            // ignore ranges with more than 5 values for now
            // this logic is need as deco location attribute could use range value 0 - 1 as its values
            if ((+range.maximum - +range.minimum) / +range.increment <= 5) {
                for (
                    let i = parseInt(String(range.minimum));
                    i <= parseInt(String(range.maximum));
                    i += parseInt(String(range.increment))
                ) {
                    defaultValues[i.toString()] = defaultValue;
                }
            }
        }
    });

    return defaultValues;
};
